module.exports = "<div> <holding-flow-sidebar-section header=\"Current Progress\" sub-header=\"{{label}}\"> <ul class=holding-dashboard-sidebar__list> <ng-transclude></ng-transclude> </ul> </holding-flow-sidebar-section> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/sidebar-progress/sidebar-progress.html
// module id = 303
// module chunks = 0